export default {
    id:"id",
    createdAt:"created_at",
    reason:"reason",
    requestType:"action_type"
};